import { Component, input, output, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-otp-input',
  imports: [ReactiveFormsModule],
  templateUrl: './otp-input.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './otp-input.component.scss'
})
export class OtpInputComponent {
  email = input<string | null>(null);
  disabled = input(false);
  otpSubmitted = output<string>();
  backToEmail = output<void>();

  private fb = inject(FormBuilder);
  otpForm: FormGroup;

  constructor() {
    this.otpForm = this.fb.group({
      otp: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]]
    });
  }

  onSubmit(): void {
    if (this.otpForm.valid) {
      this.otpSubmitted.emit(this.otpForm.value.otp);
    }
  }

  onBackToEmail(): void {
    this.backToEmail.emit();
  }
}
